<template>
    <div>
        <grid class="c-m g-m" v-if="!!objectTree && objectTree.idx > -1">
            <row :reverse="!1"  start="xs" middle="xs">
                <column :xs="3">
                    <img :src="objectTree.obj.icon" :alt="objectTree.obj.name" class="item-icon">
                </column>
                <column :xs="6">
                  <label>
                    <input class="dock-pull-input" :value="objectTree.obj.name" @input="updateValue" name="name" type="text">
                  </label>
                </column>
                <column :xs="3">
                    <div class="dock-pull-list-header" v-if="!!objectTree.obj.params.temp">
                        <i class="fas fa-thermometer-quarter"></i><b> {{objectTree.obj.params.temp}} &deg;C</b>
                    </div>
                    <div class="dock-pull-list-header" v-if="!!objectTree.obj.params.batlev">
                        <i class="far fa-battery-three-quarters"></i> <b>{{objectTree.obj.params.batlev}}%</b>
                    </div>
                </column>
            </row>
            <row :reverse="!1" middle="xs" v-if="objectTree.obj.address">
                <column :xs="2">
                  <i class="far fa-map-marker-alt fa-2x"></i>
                </column>
                <column :xs="10">
                    <h4>{{objectTree.obj.address}}</h4>
                </column>
            </row>
            <row :reverse="!1" middle="xs" v-if="objectTree.obj.date <= now_date">
              <column :xs="2">
                <span class="dock-pull-notify" v-if="objectTree.obj.date <= now_date && dateDifference(objectTree.obj.date, now_date) > 7">
                    <i class="far fa-2x fa-engine-warning"></i>
                </span>
                <i class="far fa-alarm-clock fa-2x" v-else></i>
              </column>
              <column :xs="10">
                <h3>{{objectTree.obj.date | moment('calendar')}}</h3>
              </column>
            </row>
            <row :reverse="!1" between="xs" middle="xs">
                <column :xs="4"><button class="dock-pull-button" @click="getHistory(0)">{{$t('today_label')}}</button></column>
                <column :xs="4"><button class="dock-pull-button" @click="getHistory(1)">{{$t('yesterday_label')}}</button></column>
                <column :xs="4"><button class="dock-pull-button" @click="getHistory(31)">{{$t('month_label')}}</button></column>
<!--                <column :xs="4"><button class="dock-pull-button" @click="getHistory(7)">{{$t('week_label')}}</button></column>-->
            </row>
            <row class="c-m" :reverse="!1" middle="xs" end="xs">
              <column :xs="3">
                <b>{{$t('devices.single.from_time_label')}}</b>
              </column>
              <column :xs="7">
                <datetime type="datetime"
                          input-class="dock-pull-input"
                          :max-datetime="timeMax"
                          :phrases="phrases" v-model="time1" class="theme-scanner" auto/>
              </column>
              <column :xs="2"></column>
            </row>
            <row class="c-m" :reverse="!1" middle="xs" end="xs">
              <column :xs="3">
                <b>{{$t('devices.single.to_time_label')}}</b>
              </column>
              <column :xs="7">
                <datetime type="datetime"
                          input-class="dock-pull-input"
                          v-model="time2"
                          :max-datetime="timeMax"
                          :phrases="phrases" :min-datetime="time1" class="theme-scanner" auto/>
              </column>
              <column :xs="2"></column>
            </row>
            <row class="c-m" :reverse="!1" middle="xs" center="xs">
              <column :xs-offset="0">
                <button class="dock-pull-button" @click="getHistory({start: time1, end: time2})">
                  {{$t('devices.single.show_label')}}
                </button>
              </column>
            </row>
            <row :reverse="!1" v-if="objectTree.obj.device_type === 1" class="c-m" center="xs" middle="xs">
              <column :xs="8" :xs-offset="objectTree.obj.mode !== '3' ? -1 : 12">
                <button @click="goToLink(objectTree.obj.mode_link)" class="dock-pull-button">
                  {{$t('devices.single.control_device_label')}}
                </button>
              </column>
              <column :xs="3" v-if="objectTree.obj.mode !== '3'">
                <span class="dock-pull-notify">
                  <i class="far fa-exclamation-triangle fa-2x"></i>
                </span>
              </column>
            </row>
<!--            <row class="c-m" :reverse="!1" center="xs" middle="xs">-->
<!--                <column :xs="4"><i class="far fa-stopwatch fa-2x"></i></column>-->
<!--                <column :xs="8">-->
<!--                    <div class="dock-pull-list-header">-->
<!--                        <vue-slider :dot-size="30" :height="15" :data="intervals" v-model="value" contained="true" :adsorb="true" tooltip="none"/>-->
<!--                    </div>-->
<!--                    <div class="dock-pull-list-desc">{{valueLabel}}</div>-->
<!--                </column>-->
<!--                <column :xs="1"></column>-->
<!--            </row>-->
<!--            <row class="c-m" :reverse="!1" center="xs" middle="xs">-->
<!--                <column :xs="4">-->
<!--                    <div class="dock-pull-list-header"><switches type-bold="true" v-model="enabled_acc" theme="bulma" color="default"></switches></div>-->
<!--                    <div class="dock-pull-list-desc text-center">{{$t('devices.tilt_label')}}</div>-->
<!--                </column>-->
<!--                <column :xs="4">-->
<!--                    <div class="dock-pull-list-header"><switches type-bold="true" v-model="enabled_move" theme="bulma" color="primary"></switches></div>-->
<!--                    <div class="dock-pull-list-desc text-center">{{$t('devices.motion_label')}}</div>-->
<!--                </column>-->
<!--                <column :xs="4">-->
<!--                    <div class="dock-pull-list-header"><switches type-bold="true" v-model="enabled_gps" theme="bootstrap" color="info"></switches></div>-->
<!--                    <div class="dock-pull-list-desc text-center">GPS</div>-->
<!--                </column>-->
<!--            </row>-->
<!--            <row class="c-m" :reverse="!1" middle="xs" end="xs">-->
<!--                <column :xs="3">-->
<!--                    <b>{{$t('devices.mode_label')}}</b>-->
<!--                </column>-->
<!--                <column :xs="7">-->
<!--                    <label class="dock-pull-select-label">-->
<!--                        <select class="dock-pull-select">-->
<!--                            <option>{{$t('devices.mode.sleep_label')}}</option>-->
<!--                            <option>{{$t('devices.mode.secure_label')}}</option>-->
<!--                            <option>{{$t('devices.mode.search_label')}}</option>-->
<!--                        </select>-->
<!--                    </label>-->
<!--                </column>-->
<!--                <column :xs="2"></column>-->
<!--            </row>-->
            <row class="c-m" :reverse="!1" middle="xs" end="xs">
                <column :xs="3">
                    <b>{{$t('devices.phone_label')}}</b>
                </column>
                <column :xs="7">
                    <input class="dock-pull-input" :value="objectTree.obj.phone" @input="updateValue" name="phone" type="text" readonly>
                </column>
                <column :xs="2"></column>
            </row>
            <row class="c-m" :reverse="!1" end="xs" middle="xs">
                <column :xs="3">
                    <b>{{$t('devices.imei_label')}}</b>
                </column>
                <column :xs="7">
                  <label>
                    <input class="dock-pull-input" :value="objectTree.obj.imei" @input="updateValue" name="imei" type="text" readonly>
                  </label>
                </column>
                <column :xs="2"></column>
            </row>
            <row class="dpli-h height60" :reverse="!1" center="xs" middle="xs" @click="$router.push({name: 'device_options', params: {id: $route.params.id}})">
                <column :xs="2">
                    <i class="far fa-sliders-h fa-2x"></i>
                </column>
                <column :xs="10">
                    <b>{{$t('devices.optional.settings_label')}}</b>
                </column>
            </row>
            <row class="c-m" center="xs">
                <column :xs-offset="12">
                    <button class="dock-pull-button" @click="deleteObject()">{{$t('devices.single.delete_label')}}</button>
                </column>
            </row>
        </grid>
        <div v-else>
            <div class="item">
                <div class="dock-pull-list-text">
                    <div class="dock-pull-list-header">
                        <h3>{{$t('devices.single.not_found_label')}}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import VueSlider from 'vue-slider-component'
import Switches from 'vue-switches'
import { Datetime } from 'vue-datetime'
import 'vue-slider-component/theme/antd.css'
export default {
  name: 'Device',
  components: {
    VueSlider,
    Switches,
    Datetime
  },
  data () {
    return {
      time1: (new Date()).toISOString(),
      time2: (new Date()).toISOString(),
      value: 10,
      value1: '',
      intervals: [
        10, 20, 30, 40, 50,
        60, 120, 180, 240, 300,
        360, 420, 480, 540, 600,
        660, 720, 780, 840, 900,
        960, 1020, 1080, 1140, 1200,
        1260, 1320, 1380, 1440,
        2880, 4320, 5760, 7200,
        8640, 10080
      ],
      enabled_acc: true,
      enabled_move: true,
      enabled_gps: true
    }
  },
  computed: {
    ...mapGetters({
      getObjTree: 'getObjectFromTree',
      dateDifference: 'dateDifference',
      now_date: 'nowDate'
    }),
    phrases () {
      return {ok: 'Далее', cancel: 'Отмена'}
    },
    timeMax () {
      return this.$moment().toISOString()
    },
    objectTree () {
      return this.getObjTree(this.$route.params.id)
    },
    valueLabel () {
      if (this.value < 60) {
        return this.$t('devices.every_label') + ' ' + this.value + ' ' + this.$t('devices.min_label')
      }

      if (this.value > 59 && this.value < 1440) {
        return this.$t('devices.every_label') + ' ' + (this.value / 60) + this.$t('devices.hour_label')
      }

      if (this.value > 1439 && this.value < 10081) {
        return this.$t('devices.every_label') + ' ' + (this.value / 1440) + this.$t('devices.day_label')
      }
    }
  },
  methods: {
    ...mapMutations(['dockVisibility']),
    ...mapActions(['getObjectCurrentAddress', 'updateObject']),
    ...mapActions({
      curObj: 'setCurrentDevice',
      objHistory: 'getObjectHistory',
      delObj: 'deleteObject'
    }),
    updateValue (e) {
      this.updateObject({
        idx: this.objectTree.idx,
        idxg: this.objectTree.idxg,
        value: e.target.value,
        param: e.target.name
      })
    },
    getHistory (period) {
      const flag = isFinite(period)
      const dStart = flag ? this.$moment().subtract(period, 'days').startOf('day') : this.$moment(period.start)
      const dStop = flag ? this.$moment().subtract(period === 1 ? 1 : 0, 'days').endOf('day') : this.$moment(period.end)
      const config = {
        id: this.objectTree.obj.id,
        dStart: dStart.format('YYYY-MM-DD HH:mm:ss'),
        dStop: dStop.format('YYYY-MM-DD HH:mm:ss')
      }
      console.log(config)
      this.objHistory(config).then(() => {
        this.curObj({
          idxg: this.objectTree.idxg,
          idx: this.objectTree.idx,
          id: this.objectTree.obj.id,
          group_id: this.objectTree.obj.group_id
        }).then(() => {
          this.dockVisibility(false)
          this.$router.push({name: 'Quick'})
        })
      })
    },
    deleteObject () {
      this.delObj({
        idx: this.objectTree.idx,
        idxg: this.objectTree.idxg,
        id: this.objectTree.obj.id
      })
      this.curObj({
        idxg: 0, idx: 0, noHistory: true
      }).then(() => {
        this.$router.go(-1)
      })
    },
    goToLink (link) {
      window.open(link, '_blank')
    }
  },
  watch: {
    'objectTree' (nn) {
      if (nn.obj) {
        this.getObjectCurrentAddress(nn).then(() => {
          this.$forceUpdate()
        })
      }
    }
  },
  created () {
    if (this.objectTree.obj) {
      this.getObjectCurrentAddress(this.objectTree).then(() => {
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/devices/active/Device.vue